<!--
 * @Description: 退出登录
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 14:44:21
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">确定要退出登录吗?</v-card-title>
        <v-card-text> 退出成功后将前往登录页。 </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" text @click="dialog = false">取消</v-btn> -->
          <v-btn color="green darken-1" text @click="out">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    info(state) {
      this.dialog = state;
    },
    out(){
        // user_logout
         this.$axios({
        method: "post",
        url: this.$apis.URL.user_logout,
        data: {}
      })
        .then(req => {
          if (req.data.result == 0) {
            window.console.log( req.data.datas )
            this.$Dialog.getProductCheckResult_({ text: `已安全退出登录！`, timeout: 3000, snackbar: true });
            this.$router.push({
                  path: `/`,
                  query: {}
                });
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    }
  }
};
</script>

<style>
</style>